<template>
    <div ref="mainHigh" class="mianLogin">
        <div class="logoTop">
            <div class="imgs">
               <img src="../img/logo_notext.png" alt="">
            </div>
            <p>2025年高新技术企业申报微测评</p>
            <p>本次测评时间为<span>3-5</span>分钟，为保证测试结果准确性，请如实填写。所填内容将严格保密。</p>
        </div>
        <div class="tip">
            完成以下4步快速测评
        </div>
        <div class="input-groud">
            <ul>
                <Li><span>1</span>基础条件</Li>
                <Li><span>2</span>财务成长性</Li>
                <Li><span>3</span>知识产权和成果转化</Li>
                <Li><span>4</span>研发组织管理水平</Li>
            </ul>
        </div>
        <a-button class="subtn" size="large" type="primary"  @click="goMore('/webHighEnterpriseEvaluation/test')">开始测评</a-button>
    </div>
  </template>

  <script>
  import { basicsEvaluateInfo } from "@/api/webHighEnterpriseEvaluation";
  import {ls} from "@/utils/util";
  export default {
    data () {
        return {
            logoState:false,

        }
    },
    mounted() {
      this.$refs.mainHigh.style.height = window.innerHeight+'px'
        if(ls.get('wxLoginPhone')){
            this.logoState = true
        }else{
            this.goMore('/webHighEnterpriseEvaluation/login')
        }
    },
    methods: {
        //获取说明
        getEvaluateInfo() {
            this.getAction({
                url: basicsEvaluateInfo.getEvaluateInfo,
            }
            ).then(() => {


            })
        },
        //路由跳转
        goMore(url, str) {
            if(str){
                this.$router.push({ path: url, query: { id: str } })
            }else{
                this.$router.push(url)
            }
        },
    }
  };
  </script>
  <style lang="less" scoped>
  .mianLogin{
    font-family: '微软雅黑';
    width:100%;
    background: url(../img/bg.jpg) no-repeat;
    background-size: 100% 100%;
    display: flex;
    min-height: 40rem;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .logoTop{
        width:85%;margin-top: -5rem;
        .imgs{
            border-radius: 8rem;
            width:7rem;
            height:7rem;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom:2rem;
            img{
                width:80%
            }
        }
        p{
            font-size: .85rem;
            font-weight: bold;
            span{
                color:#1c4ff7
            }
        }
    }
    .tip{
        background: url(../img/tipbg.png) no-repeat 0 0;
        line-height: 3rem;
        margin-top:1rem;
        margin-bottom:-2.85rem;
        color:#fff;
        font-size: .85rem;
        font-weight: bold;
        background-size: 70%;
        width:85%;
        padding-left: 1.2rem;
        height: 4rem;
    }
    .input-groud{
        display: flex;
        margin-top:1.5rem;
        flex-direction: column;
        width:90%;
        padding: 1rem 0 .5rem 2.5rem;
        background: url(../img/bg2.png) no-repeat #fff 12rem 2rem;
        background-size: 40%;
        position: relative;
        border-radius: .65rem;
        li{
            line-height: 2.5rem;
            font-weight: bold;
            font-size: .85rem;
            span{
                margin-right:1rem;
                color:#1c4ff7
            }
        }
    }
    .subtn{
        width:90%;
        margin-top:1rem;
        line-height: 2rem;
        height:2.8rem;
        border-radius: .65rem;
        font-size: 1rem;
        background: #1c4ff7;
        font-weight: bold;
        text-align: center;
    }
  }
  </style>
